import { CurrenciesProvider } from "./types";

// Тип для метаданных провайдера
interface ProviderMeta {
  id: CurrenciesProvider;
  name: string;
  displayName: string;
}

// Объект с метаданными всех провайдеров
export const CurrenciesProvidersMeta: Record<CurrenciesProvider, ProviderMeta> = {
  [CurrenciesProvider.ByBit]: {
    id: CurrenciesProvider.ByBit,
    name: 'ByBit',
    displayName: 'ByBit'
  },
  [CurrenciesProvider.Rapira]: {
    id: CurrenciesProvider.Rapira,
    name: 'Rapira',
    displayName: 'Rapira'
  }
};

// Helper функции
export const CurrenciesProviderHelpers = {
  getAll: (): ProviderMeta[] => Object.values(CurrenciesProvidersMeta),

  getByName: (name: string): ProviderMeta | undefined =>
    Object.values(CurrenciesProvidersMeta).find(p => p.name === name),

  getById: (id: CurrenciesProvider): ProviderMeta => CurrenciesProvidersMeta[id],

  isValid: (name: string): boolean =>
    Object.values(CurrenciesProvidersMeta).some(p => p.name === name)
};